export namespace Constants
{
    const NAME:string = "zmenu";
}



// WEBPACK FOOTER //
// ./src/modules/zmenu/constants.ts